import * as React from "react";
import {GetCliente} from "../../services/cliente.service";
import './face-validation-erro.css';

interface State {
  nomeCliente: string;

}

export default class FaceValidationErroComponent extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      nomeCliente: ""
      
    };
  }

  componentDidMount() {
    this.getUser();
  }

  async getUser(){
    const response = await GetCliente();
    const nome = response.nome;
    this.setState(
      {
        nomeCliente: nome
      }
    );
  }

  render() {
    const currentDate = new Date();
    const formattedDate = `${currentDate.toLocaleDateString()} às ${currentDate.toLocaleTimeString()}`;
    const { nomeCliente } = this.state;
    return (
      <div className="face-validation-erro">
        <div className="face-validation-erro-content">
          <div className="logo">
            <img className="img-logo" src="src/assets/images/logo-bmg.png" />
          </div>
          <div className="erro"> 
            <img className="img-erro" src="src/assets/images/erro.png" />
          </div>
          <div className="face-validation-erro-link-description">
            <h1 className="face-validation-erro-text-link-description">Selfie não capturada!</h1>
          </div>
          <div className="face-validation-erro-date-description">
            <label className="face-validation-erro-text-date-description">
              {formattedDate}
            </label>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="description">
            <p className="text-description">
            {`${nomeCliente}, não conseguimos capturar sua foto. Siga com atendimento na central para receber orientação.`}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
